import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import DownloadTemplate from './DownloadTemplate';
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../components/SweetAlert";

import {
    bytesToSize
} from '../../../helpers/general'

import csvIcon from '../../../assets/icons/csv.png'

const UploadFile = ({ url, handleCloseModal, otherData, template, setModalResponseError }) => {
    const token = localStorage.getItem('token')
    const [rawFiles, setRawFiles] = useState([])
    const handleAccept = files => setRawFiles(files)
    const handleReject = (fileRejections) => {
        ToastUtil.error("Invalid file type. Please upload a CSV file.");
      };
    const [isLoading, setIsLoading] = useState(false)

    const uploadHandler = async e => {
        e.preventDefault()
        setIsLoading(true)
        if (setModalResponseError !== undefined) {
            setModalResponseError('');
        }

        if (rawFiles.length > 0) {
            const isConfirmed = await AlertService.confirm("", 'Are you sure you want to upload this file?');
            if (isConfirmed) {
                try {
                    let formData = new FormData();
                    formData.append('file', rawFiles[0])
    
                    if (otherData !== undefined) {
                        for ( var key in otherData ) {
                            formData.append(key, otherData[key])
                        }
                        
                    }
    
                    let response = await fetch(url, {
                        mode: 'cors',
                        method: 'POST',
                        body: formData,
                        withCredentials: true,
                        headers: {
                            "Authorization": token
                        }
                    })
    
                    let responseData = await response.json()
    
                    if (response.ok) {
                        ToastUtil.success(responseData.message);
                        window.location.reload()
                        setIsLoading(false)
                    } else {
                        if (responseData.existClockedin) {
                            const isConfirmed = await AlertService.confirm("", responseData.message);
                            if (isConfirmed) {
                                formData.append('admin_confirm', true)
                                let response = await fetch(url, {
                                    mode: 'cors',
                                    method: 'POST',
                                    body: formData,
                                    withCredentials: true,
                                    headers: {
                                        "Authorization": token
                                    }
                                })
                                let responseData = await response.json()
                                if (response.ok) {
                                    ToastUtil.success(responseData.message);
                                    window.location.reload()
                                    setIsLoading(false)
                                } else {
                                    ToastUtil.error(responseData.message);
                                    setIsLoading(false)
                                }
                            } else {
                                setIsLoading(false)
                            }
                        } else {
                            if (setModalResponseError !== undefined) {
                                setModalResponseError(responseData.message);
                            }
                            ToastUtil.error(responseData.message);
                            setIsLoading(false)
                        }
                    }
                } catch (error) {
                    console.log(error)
                }
            }  else {
                setIsLoading(false)
            }  
        } else {
            ToastUtil.error('No file detected!');
            setIsLoading(false)
        }
    }

    return (
        <form className="d-flex flex-column justify-content-between flex-grow-1" onSubmit={e => uploadHandler(e)}>
        {
            rawFiles[0] 
                ? (
                    <div className="d-flex w-100 flex-row justify-content-between align-items-center border rounded p-4" style={{backgroundColor: '#f8f8f8'}}>
                        <img src={csvIcon} style={{width: '50px'}} alt=""/>
                        <div className="d-flex flex-column flex-grow-1 ms-4">
                            <div>{rawFiles[0].name}</div>
                            <small className="text-muted">{bytesToSize(rawFiles[0].size)}</small>
                        </div>
                        
                    </div>
                ) 
                : (
                    <Dropzone
                        multiple={false}
                        onDrop={handleAccept}
                        onRejected={event => handleReject(event)}
                        accept='.csv' >
                        {({getRootProps, getInputProps}) => (
                                <div {...getRootProps({
                                    className: "d-flex w-100 flex-column justify-content-center align-items-center rounded text-center p-4",
                                    style: {border: '2px dashed #e3e3e3'}
                                })}>
                                    <input {...getInputProps()} />
                                    <i className="fas fa-upload fa-3x text-brand"></i>
                                    <p className="pt-3">You can also upload files by</p>
                                    <p className="text-brand">Clicking here</p>
                                </div>
                        )}
                    </Dropzone>
                )
        }{ template && 
            <DownloadTemplate template={template} />
        }
        <div className="d-flex justify-content-end mt-auto pt-3 border-top">
            <button type="button" disabled={isLoading ? true : false} onClick={handleCloseModal} className="btn btn-outline-brand" style={{width:'12rem'}}>Cancel</button>
            <button
                type="submit"
                disabled={isLoading ? true : false}
                className={
                isLoading ? "btn btn-brand ms-3 loading" : "btn btn-brand ms-3"
                }
                style={{ width: "12rem", position: "relative", height: "38px" }}
            >
                <div className="spinner" />
                <p className="text">Upload</p>
            </button>
        </div>
    </form>
    )
}

export default UploadFile
